<template>
  <div class="start flex flex-wrap -mx-2">
    <div class="w-full">
      <h1 class="mb-6">Unsere Öffnungszeiten</h1>
      <ul>
        <li v-for="(day, dayIndex) in open" class="my-6">
          <strong>{{ dayIndex | day }}</strong>
          <div v-if="day === null">Ruhetag</div>
          <ul class="mt-2" v-if="day !== null">
            <li v-for="hour in day">{{ hour.item_open }} bis {{ hour.item_close }} Uhr</li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import endpoints from '../../endpoints'
import axios from 'axios'

export default {
  name: 'Oeffnungszeiten',

  data () {
    return {
      hostId: window.hostId,
      open: {}
    }
  },

  created () {
    axios.post(endpoints.hostopen, {
      'hostId': this.hostId
    })
      .then(response => {
        this.open = response.data.open
      })
      .catch(e => {
        console.log(e)
      })
  },

  filters: {
    day (day) {
      if (day == 1) return 'Montags'
      if (day == 2) return 'Dienstags'
      if (day == 3) return 'Mittwochs'
      if (day == 4) return 'Donnerstags'
      if (day == 5) return 'Freitags'
      if (day == 6) return 'Samstags'
      if (day == 7) return 'Sonntags'
      if (day == 8) return 'An Feiertagen'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/openinghours/index.vue